<template>
  <div v-if="translatedHelpText"
    class="text-help d-print-none form-text text-muted d-flex flex-nowrap"
    :class="[helpClass, this.truncateText ? 'align-items-center' : 'align-items-start']">
    <i :class="['fas fa-info-circle pr-1', {'pt-1': !this.truncateText}]" data-toggle="tooltip-city" data-placement="right" :title="translatedHelpText"></i>
    <span v-if="!onlyIcon" :class="helpFieldClass" v-html="translatedHelpText"></span>
  </div>
</template>

<script>

export default {
    name: 'help-span',
    props: {
      onlyIcon: {
        type: Boolean,
        default: false,
      },
      helpText: {
        type: String,
        default: null
      },
      helpClass: {
        type: String,
        default: 'small',
      },
      fieldClass: {
        type: String,
        default: 'flex-fill',
      },
      truncateText: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {

      }
    },
    mounted() {
      this.$root.$helper.global.activeTooltip('boundary');
    },
    computed: {
      helpFieldClass() {
        return [this.fieldClass, this.truncateText ? 'text-truncate' : ''].filter(x => x).join(' ');
      },
      translatedHelpText() {
        return this.helpText ? this.$t(this.helpText) : null;
      }
    },
    methods: {

    },
    watch: {

    },


}
</script>

<style lang="scss" scoped>

</style>